import React from 'react';
import { Check, Star, Crown, Sparkles, Zap, Heart, MapPin, Phone } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

// Packs Mariages Lubumbashi
const weddingLubumbashiPacks = [
  {
    id: 1,
    name: 'Pack Basique Mariage Lubumbashi',
    price: '400',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Préparatif de Marié',
      'Mariage civil',
      'Mariage religieux',
      'Séance photo',
      'Soirée',
      'Album photo VIP'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Mariage Lubumbashi',
    price: '500',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (80 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A3 (portrait A3 imprimé sur bois)',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Flash avec photo et vidéo'
    ],
    highlighted: true,
    badge: 'Populaire'
  },
  {
    id: 3,
    name: 'Pack Pro Mariage Lubumbashi',
    price: '700',
    description: 'Photographie et vidéographie complète',
    icon: Zap,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Vidéo résumé mariage (45min à 1h30) avec musique, transitions et textes (noms et date)',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (80 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A3 (portrait A3 imprimé sur bois)',
      'Flash avec photo et vidéo mariage'
    ],
    highlighted: false
  },
  {
    id: 4,
    name: 'Pack VIP Mariage Lubumbashi',
    price: '1,000',
    description: 'Service complet premium',
    icon: Crown,
    features: [
      'Équipe: 2 vidéastes (2 angles) + 1 photographe + Drone',
      'Film de mariage histoire d amour (2h à 2h30) avec interview, musique, transitions et textes',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Interview avec le marié et leurs proches sur leur parcours relationnel',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (120 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A2 (portrait A2 imprimé sur bois)',
      'Affiche save the date mariage',
      'Flash avec photo et vidéo mariage',
      'Garantie de création d une galerie pour sécuriser vos photos et vidéos sur notre site en cas de perte'
    ],
    highlighted: false,
    badge: 'Premium'
  }
];

// Packs Dot Lubumbashi
const dotLubumbashiPacks = [
  {
    id: 1,
    name: 'Pack Basique Dot Lubumbashi',
    price: '130',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos essentielles',
      'Moments clés capturés'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Dot Lubumbashi',
    price: '200',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos complètes',
      'Vidéo de la cérémonie',
      'Moments importants'
    ],
    highlighted: true,
    badge: 'Recommandé'
  },
  {
    id: 3,
    name: 'Pack Pro Dot Lubumbashi',
    price: '320',
    description: 'Service complet avec interviews',
    icon: Zap,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos professionnelles',
      'Vidéo complète',
      'Interviews des participants',
      'Moments culturels capturés',
      'Drone',
      'Interview avec le mariage'
    ],
    highlighted: false
  }
];

// Packs Mariages Kolwezi
const weddingKolweziPacks = [
  {
    id: 1,
    name: 'Pack Basique Mariage Kolwezi',
    price: '400',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Préparatif de Marié',
      'Mariage civil',
      'Mariage religieux',
      'Séance photo',
      'Soirée',
      'Album photo VIP'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Mariage Kolwezi',
    price: '500',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (80 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A3 (portrait A3 imprimé sur bois)',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Flash avec photo et vidéo'
    ],
    highlighted: true,
    badge: 'Populaire'
  },
  {
    id: 3,
    name: 'Pack Pro Mariage Kolwezi',
    price: '700',
    description: 'Photographie et vidéographie complète',
    icon: Zap,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Vidéo résumé mariage (45min à 1h30) avec musique, transitions et textes (noms et date)',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (80 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A3 (portrait A3 imprimé sur bois)',
      'Flash avec photo et vidéo mariage'
    ],
    highlighted: false
  },
  {
    id: 4,
    name: 'Pack VIP Mariage Kolwezi',
    price: '1,000',
    description: 'Service complet premium',
    icon: Crown,
    features: [
      'Équipe: 2 vidéastes (2 angles) + 1 photographe + Drone',
      'Film de mariage histoire d amour (2h à 2h30) avec interview, musique, transitions et textes',
      'Teaser du résumé du mariage (3 minutes) pour réseaux sociaux',
      'Interview avec le marié et leurs proches sur leur parcours relationnel',
      'Photos numériques HD illimitées retouchées avec soin (format JPG)',
      'Un album photos VIP (120 photos choisies par vous imprimées avec soins, insérées dans l album)',
      'Portrait A2 (portrait A2 imprimé sur bois)',
      'Affiche save the date mariage',
      'Flash avec photo et vidéo mariage',
      'Garantie de création d une galerie pour sécuriser vos photos et vidéos sur notre site en cas de perte'
    ],
    highlighted: false,
    badge: 'Premium'
  }
];

// Packs Dot Kolwezi
const dotKolweziPacks = [
  {
    id: 1,
    name: 'Pack Basique Dot Kolwezi',
    price: '230',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos essentielles',
      'Moments clés capturés'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Dot Kolwezi',
    price: '350',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos complètes',
      'Vidéo de la cérémonie',
      'Moments importants'
    ],
    highlighted: true,
    badge: 'Recommandé'
  },
  {
    id: 3,
    name: 'Pack Pro Dot Kolwezi',
    price: '450',
    description: 'Service complet avec interviews',
    icon: Zap,
    features: [
      'Remise dot',
      'Mariage coutumier',
      'Photos professionnelles',
      'Vidéo complète',
      'Interviews des participants',
      'Moments culturels capturés',
      'Drone',
      'Interview avec le mariage'
    ],
    highlighted: false
  }
];

// Packs Conférence Lubumbashi
const conferenceLubumbashiPacks = [
  {
    id: 1,
    name: 'Pack Basique Conférence Lubumbashi',
    price: '200',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Couverture photographique complète',
      'Photos des intervenants',
      'Photos du public',
      'Moments clés de la conférence',
      'Photos numériques HD retouchées'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Conférence Lubumbashi',
    price: '500',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Couverture photo et vidéo complète',
      'Captation des présentations',
      'Interviews des intervenants',
      'Photos numériques HD retouchées',
      'Vidéo résumé (10-15 minutes)',
      'Teaser pour réseaux sociaux (2 minutes)'
    ],
    highlighted: true,
    badge: 'Populaire'
  },
  {
    id: 3,
    name: 'Pack Pro Conférence Lubumbashi',
    price: '900',
    description: 'Photographie et vidéographie professionnelle',
    icon: Zap,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Multi-caméras pour captation complète',
      'Enregistrement audio professionnel',
      'Captation de toutes les sessions',
      'Photos numériques HD illimitées',
      'Vidéo montée professionnelle (30-45 minutes)',
      'Teaser réseaux sociaux',
      'Retransmission en direct (streaming)',
      'Album photo de l\'événement'
    ],
    highlighted: false
  },
  {
    id: 4,
    name: 'Pack VIP Conférence Lubumbashi',
    price: '1,500',
    description: 'Service complet premium',
    icon: Crown,
    features: [
      'Équipe: 2 vidéastes (multi-angles) + 1 photographe + Drone',
      'Captation complète multi-caméras',
      'Enregistrement audio broadcast',
      'Retransmission en direct HD (streaming)',
      'Interviews exclusives des intervenants',
      'Vidéo professionnelle complète (1h-2h)',
      'Teaser et extraits pour réseaux sociaux',
      'Photos numériques HD illimitées',
      'Album photo premium (100 photos)',
      'Galerie en ligne sécurisée',
      'Support technique sur place'
    ],
    highlighted: false,
    badge: 'Premium'
  }
];

// Packs Conférence Kolwezi
const conferenceKolweziPacks = [
  {
    id: 1,
    name: 'Pack Basique Conférence Kolwezi',
    price: '200',
    description: 'Photographie uniquement',
    icon: Sparkles,
    features: [
      'Couverture photographique complète',
      'Photos des intervenants',
      'Photos du public',
      'Moments clés de la conférence',
      'Photos numériques HD retouchées'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Pack Standard Conférence Kolwezi',
    price: '500',
    description: 'Photographie et vidéographie',
    icon: Star,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Couverture photo et vidéo complète',
      'Captation des présentations',
      'Interviews des intervenants',
      'Photos numériques HD retouchées',
      'Vidéo résumé (10-15 minutes)',
      'Teaser pour réseaux sociaux (2 minutes)'
    ],
    highlighted: true,
    badge: 'Populaire'
  },
  {
    id: 3,
    name: 'Pack Pro Conférence Kolwezi',
    price: '900',
    description: 'Photographie et vidéographie professionnelle',
    icon: Zap,
    features: [
      'Équipe: 1 photographe + 1 Vidéaste',
      'Multi-caméras pour captation complète',
      'Enregistrement audio professionnel',
      'Captation de toutes les sessions',
      'Photos numériques HD illimitées',
      'Vidéo montée professionnelle (30-45 minutes)',
      'Teaser réseaux sociaux',
      'Retransmission en direct (streaming)',
      'Album photo de l\'événement'
    ],
    highlighted: false
  },
  {
    id: 4,
    name: 'Pack VIP Conférence Kolwezi',
    price: '1,500',
    description: 'Service complet premium',
    icon: Crown,
    features: [
      'Équipe: 2 vidéastes (multi-angles) + 1 photographe + Drone',
      'Captation complète multi-caméras',
      'Enregistrement audio broadcast',
      'Retransmission en direct HD (streaming)',
      'Interviews exclusives des intervenants',
      'Vidéo professionnelle complète (1h-2h)',
      'Teaser et extraits pour réseaux sociaux',
      'Photos numériques HD illimitées',
      'Album photo premium (100 photos)',
      'Galerie en ligne sécurisée',
      'Support technique sur place'
    ],
    highlighted: false,
    badge: 'Premium'
  }
];

const WHATSAPP_NUMBER = "243999006868"; // Numéro WhatsApp GOS MÉDIA (sans le +)

const Pricing = () => {
  const handleWhatsAppReservation = (packName, price, city, eventType) => {
    const message = `Bonjour GOS MÉDIA! Je souhaite réserver le ${packName} à ${price}$ pour ${eventType} à ${city}.`;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const renderPricingCards = (packs, city, eventType) => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {packs.map((plan, index) => {
          const Icon = plan.icon;
          return (
            <Card 
              key={plan.id}
              className={`relative overflow-hidden transition-all duration-500 hover:-translate-y-3 animate-fade-in ${
                plan.highlighted 
                  ? 'border-2 border-amber-500 shadow-2xl shadow-amber-500/20 scale-105' 
                  : 'border-0 shadow-lg hover:shadow-2xl'
              }`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {plan.badge && (
                <div className="absolute top-4 right-4 z-10">
                  <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                    {plan.badge}
                  </span>
                </div>
              )}

              <CardHeader className="text-center pb-8 pt-10">
                <div className="mx-auto mb-6">
                  <div className={`w-20 h-20 rounded-2xl flex items-center justify-center ${
                    plan.highlighted 
                      ? 'bg-gradient-to-br from-amber-400 to-amber-600' 
                      : 'bg-gradient-to-br from-gray-100 to-gray-200'
                  }`}>
                    <Icon className={`h-10 w-10 ${plan.highlighted ? 'text-white' : 'text-gray-700'}`} />
                  </div>
                </div>

                <CardTitle className="text-2xl font-bold mb-2">
                  {plan.name}
                </CardTitle>
                
                <CardDescription className="text-base text-gray-600 mb-6 min-h-[48px]">
                  {plan.description}
                </CardDescription>

                <div className="mb-6">
                  <div className="text-4xl font-bold text-gray-900 mb-1">
                    ${plan.price}
                  </div>
                  <div className="text-sm text-gray-500 font-semibold">USD</div>
                </div>
              </CardHeader>

              <CardContent className="px-6 pb-8">
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${
                        plan.highlighted ? 'bg-amber-100' : 'bg-gray-100'
                      }`}>
                        <Check className={`h-3 w-3 ${plan.highlighted ? 'text-amber-600' : 'text-gray-600'}`} />
                      </div>
                      <span className="text-sm text-gray-700 leading-tight">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  onClick={() => handleWhatsAppReservation(plan.name, plan.price, city, eventType)}
                  className={`w-full h-12 rounded-xl font-semibold text-base transition-all duration-300 hover:scale-105 ${
                    plan.highlighted
                      ? 'bg-green-500 hover:bg-green-600 text-white shadow-lg'
                      : 'bg-green-500 hover:bg-green-600 text-white'
                  }`}
                >
                  <Phone className="mr-2 h-4 w-4" />
                  Réserver sur WhatsApp
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-amber-100/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-50/30 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <Star className="h-4 w-4 fill-amber-600" />
            Nos Tarifs
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            Des Forfaits Adaptés à
            <span className="bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent"> Chaque Événement</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            Choisissez le pack qui correspond à vos besoins. Réservez directement sur WhatsApp !
          </p>
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-6 py-3 rounded-full text-base font-semibold">
            🎉 <span className="font-bold">-10%</span> de réduction en réservant 1 mois avant l'événement
          </div>
        </div>

        <Tabs defaultValue="mariage-lubumbashi" className="w-full">
          <TabsList className="grid w-full max-w-6xl mx-auto grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-2 mb-12 h-auto p-2 bg-white shadow-lg rounded-2xl">
            <TabsTrigger 
              value="mariage-lubumbashi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <MapPin className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Mariage Lshi
            </TabsTrigger>
            <TabsTrigger 
              value="dot-lubumbashi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Crown className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Dot Lshi
            </TabsTrigger>
            <TabsTrigger 
              value="conference-lubumbashi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-500 data-[state=active]:to-blue-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Star className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Conf Lshi
            </TabsTrigger>
            <TabsTrigger 
              value="mariage-kolwezi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <MapPin className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Mariage Kwz
            </TabsTrigger>
            <TabsTrigger 
              value="dot-kolwezi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Crown className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Dot Kwz
            </TabsTrigger>
            <TabsTrigger 
              value="conference-kolwezi" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-500 data-[state=active]:to-blue-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Star className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Conf Kwz
            </TabsTrigger>
            <TabsTrigger 
              value="autres" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Heart className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Autre Pack
            </TabsTrigger>
            <TabsTrigger 
              value="personnalise" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-amber-600 data-[state=active]:text-white rounded-xl py-3 px-2 text-xs md:text-sm font-semibold transition-all whitespace-nowrap"
            >
              <Sparkles className="h-3 w-3 md:h-4 md:w-4 mr-1" />
              Personnalisé
            </TabsTrigger>
          </TabsList>

          <TabsContent value="mariage-lubumbashi" className="mt-8">
            {renderPricingCards(weddingLubumbashiPacks, "Lubumbashi", "Mariage")}
          </TabsContent>

          <TabsContent value="dot-lubumbashi" className="mt-8">
            {renderPricingCards(dotLubumbashiPacks, "Lubumbashi", "Dot")}
          </TabsContent>

          <TabsContent value="conference-lubumbashi" className="mt-8">
            {renderPricingCards(conferenceLubumbashiPacks, "Lubumbashi", "Conférence")}
          </TabsContent>

          <TabsContent value="mariage-kolwezi" className="mt-8">
            {renderPricingCards(weddingKolweziPacks, "Kolwezi", "Mariage")}
          </TabsContent>

          <TabsContent value="dot-kolwezi" className="mt-8">
            {renderPricingCards(dotKolweziPacks, "Kolwezi", "Dot")}
          </TabsContent>

          <TabsContent value="conference-kolwezi" className="mt-8">
            {renderPricingCards(conferenceKolweziPacks, "Kolwezi", "Conférence")}
          </TabsContent>

          <TabsContent value="autres" className="mt-8">
            <div className="max-w-4xl mx-auto">
              <Card className="border-2 border-amber-500 shadow-2xl">
                <CardHeader className="text-center pb-8 pt-12">
                  <div className="mx-auto mb-6">
                    <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-amber-600 rounded-3xl flex items-center justify-center">
                      <Heart className="h-12 w-12 text-white" />
                    </div>
                  </div>
                  <CardTitle className="text-4xl font-bold mb-4">
                    Autres Événements
                  </CardTitle>
                  <CardDescription className="text-lg text-gray-600">
                    Concerts, Conférences, Événements Gouvernementaux et plus
                  </CardDescription>
                </CardHeader>
                <CardContent className="px-8 pb-12">
                  <div className="bg-amber-50 rounded-2xl p-8 mb-8">
                    <p className="text-gray-700 text-lg text-center mb-6">
                      Pour les concerts, conférences, séminaires, événements gouvernementaux et autres célébrations, 
                      contactez-nous avec votre budget. Nous trouvons toujours une solution adaptée, même pour les budgets serrés !
                    </p>
                  </div>
                  <div className="text-center">
                    <Button
                      onClick={() => {
                        const message = "Bonjour GOS MÉDIA! Je souhaite discuter d'un événement spécial (concert/conférence/autre).";
                        const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
                        window.open(url, '_blank');
                      }}
                      size="lg"
                      className="bg-green-500 hover:bg-green-600 text-white px-12 py-6 text-lg font-semibold rounded-xl shadow-xl transition-all duration-300 hover:scale-105"
                    >
                      <Phone className="mr-2 h-5 w-5" />
                      Contactez-nous sur WhatsApp
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          <TabsContent value="personnalise" className="mt-8">
            <div className="max-w-4xl mx-auto">
              <Card className="border-2 border-amber-500 shadow-2xl bg-gradient-to-br from-white to-amber-50">
                <CardHeader className="text-center pb-8 pt-12">
                  <div className="mx-auto mb-6">
                    <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-amber-600 rounded-3xl flex items-center justify-center">
                      <Sparkles className="h-12 w-12 text-white" />
                    </div>
                  </div>
                  <CardTitle className="text-4xl font-bold mb-4">
                    Pack Personnalisé
                  </CardTitle>
                  <CardDescription className="text-lg text-gray-600">
                    Créez votre pack sur mesure selon votre budget et vos besoins
                  </CardDescription>
                </CardHeader>
                <CardContent className="px-8 pb-12">
                  <div className="bg-white rounded-2xl p-8 mb-8 shadow-md">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                      ✨ Personnalisez Votre Couverture
                    </h3>
                    <p className="text-gray-700 text-lg text-center mb-6">
                      Vous avez un budget spécifique ? Des besoins particuliers ? Nous créons un pack sur mesure adapté à vos attentes !
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                      <div className="bg-amber-50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
                            <Check className="h-5 w-5 text-white" />
                          </div>
                          <h4 className="font-bold text-gray-900">Choisissez vos services</h4>
                        </div>
                        <p className="text-sm text-gray-600 ml-11">
                          Photo, vidéo, drone, portraits... Sélectionnez ce dont vous avez besoin
                        </p>
                      </div>

                      <div className="bg-amber-50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
                            <Check className="h-5 w-5 text-white" />
                          </div>
                          <h4 className="font-bold text-gray-900">Définissez votre budget</h4>
                        </div>
                        <p className="text-sm text-gray-600 ml-11">
                          Nous adaptons notre offre à votre budget disponible
                        </p>
                      </div>

                      <div className="bg-amber-50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
                            <Check className="h-5 w-5 text-white" />
                          </div>
                          <h4 className="font-bold text-gray-900">Durée flexible</h4>
                        </div>
                        <p className="text-sm text-gray-600 ml-11">
                          De 2h à toute la journée, vous choisissez la durée
                        </p>
                      </div>

                      <div className="bg-amber-50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
                            <Check className="h-5 w-5 text-white" />
                          </div>
                          <h4 className="font-bold text-gray-900">Devis gratuit</h4>
                        </div>
                        <p className="text-sm text-gray-600 ml-11">
                          Recevez votre devis personnalisé en 24h
                        </p>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-amber-100 to-amber-50 rounded-xl p-6 mb-6">
                      <p className="text-center text-gray-800 font-semibold text-lg">
                        💡 <span className="text-amber-700">Astuce :</span> Plus vous réservez tôt, plus nous pouvons optimiser votre pack !
                      </p>
                    </div>
                  </div>

                  <div className="text-center">
                    <Button
                      onClick={() => {
                        const message = "Bonjour GOS MÉDIA! Je souhaite créer un pack personnalisé selon mon budget et mes besoins.";
                        const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
                        window.open(url, '_blank');
                      }}
                      size="lg"
                      className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-12 py-6 text-lg font-semibold rounded-xl shadow-xl shadow-amber-500/30 hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105"
                    >
                      <Phone className="mr-2 h-5 w-5" />
                      Créer Mon Pack Personnalisé
                    </Button>
                    <p className="text-gray-500 text-sm mt-4">
                      Réponse en moins de 2 heures • Devis gratuit sans engagement
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Pricing;
